import { defaultSchema } from 'rehype-sanitize';
import { ExternalLinkOptions, SanitizerOptions } from '../entities';
import { isExternalLink } from '../utils/isExternalLink';

export const externalLinkOptions: ExternalLinkOptions = {
  rel: ['nofollow'],
  test: isExternalLink,
};

export const tableTagNames = ['table', 'thead', 'tbody', 'tr', 'th', 'td', 'caption'];

export const sanitizeOptions: SanitizerOptions = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames || []), ...tableTagNames],
  attributes: {
    ...defaultSchema.attributes,
    a: [...(defaultSchema.attributes?.a || []), 'rel'],
    table: [...(defaultSchema.attributes?.table || []), 'border', 'cellpadding', 'cellspacing', 'width'],
    th: [...(defaultSchema.attributes?.th || []), 'scope', 'colspan', 'rowspan', 'align', 'valign'],
    td: [...(defaultSchema.attributes?.td || []), 'colspan', 'rowspan', 'align', 'valign'],
  },
};
